module.exports = __webpack_public_path__ + "img/icon_5_64.9a899f9e.png";